import { render, staticRenderFns } from "./SamplesPaginator.vue?vue&type=template&id=535f2aa8&scoped=true&"
import script from "./SamplesPaginator.vue?vue&type=script&lang=js&"
export * from "./SamplesPaginator.vue?vue&type=script&lang=js&"
import style0 from "./SamplesPaginator.vue?vue&type=style&index=0&id=535f2aa8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535f2aa8",
  null
  
)

export default component.exports